import Axios from "axios";

class FuncionarioPontoPeriodoDataService {
  getFuncionarios() {
    return Axios.get("funcionarios");
  }

  getAll() {
    return Axios.get("funcionarioPontoPeriodos");
  }

  getPage(params) {
    return Axios.get("funcionarioPontoPeriodos/page", { params });
  }

  create(params) {
    return Axios.post("funcionarioPontoPeriodos", params);
  }

  update(params) {
    return Axios.put("funcionarioPontoPeriodos/" + params.id, params);
  }

  find(id) {
    return Axios.get(`funcionarioPontoPeriodos/${id}`);
  }

  findHistorico(id) {
    return Axios.get(`funcionarioPontoPeriodos/${id}/historico`);
  }

  printHistorico(id, config) {
    return Axios.get(`funcionarioPontoPeriodos/${id}/historico/pdf`, config);
  }

  delete(id) {
    return Axios.delete(`funcionarioPontoPeriodos/${id}`);
  }
}

export default new FuncionarioPontoPeriodoDataService();
